import { render, staticRenderFns } from "./ehc-organization-add-member.vue?vue&type=template&id=fd14afa2"
import script from "./ehc-organization-add-member.vue?vue&type=script&lang=js"
export * from "./ehc-organization-add-member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports